export default "__VITE_ASSET__6IFkvakN__"